import {cannotResolveOptionType, workMode, handleType, userRoles} from "_constants";

export default [
    {
        label: `No response needed because this is spam or "thanks"`,
        value: cannotResolveOptionType.NO_RESPONSE_NEEDED,
        supportedWorkMode: [workMode.ACTIVE, workMode.PRACTICE],
        supportedRoles: [userRoles.CHATDESK_ADMIN_ROLE, userRoles.BILLING_ADMIN_ROLE, userRoles.CHATDESK_AGENT_ROLE]
    },
    {
        label: `I don't know how to answer this, but another Chatdesk Expert might`,
        value: cannotResolveOptionType.REROUTE,
        supportedWorkMode: [workMode.ACTIVE],
        supportedRoles: [userRoles.CHATDESK_AGENT_ROLE]
    },
    {
        label: `I was told to escalate this type of message e.g. very angry customer, health concerns, etc`,
        value: cannotResolveOptionType.ESCALATE,
        supportedWorkMode: [workMode.ACTIVE, workMode.PRACTICE],
        supportedRoles: [userRoles.CHATDESK_ADMIN_ROLE, userRoles.BILLING_ADMIN_ROLE, userRoles.CHATDESK_AGENT_ROLE]
    },
    {
        label: `I will leave an internal note for the company`,
        value: cannotResolveOptionType.INTERNAL_NOTE,
        supportedWorkMode: [workMode.ACTIVE],
        supportedHandleTypes: [handleType.email],
        supportedRoles: [userRoles.CHATDESK_ADMIN_ROLE, userRoles.BILLING_ADMIN_ROLE, userRoles.CHATDESK_AGENT_ROLE]
    },
    {
        label: `I was told to skip this type of message`,
        value: cannotResolveOptionType.SKIPPED,
        supportedWorkMode: [workMode.ACTIVE, workMode.PRACTICE],
        supportedRoles: [userRoles.CHATDESK_AGENT_ROLE]
    },
]